export const UNIT_DEGREES = "deg";
export const UNIT_RADIANS = "rad";

export const CALCULATOR_UNITS = [
  { label: "DEG", value: UNIT_DEGREES },
  { label: "RAD", value: UNIT_RADIANS },
];

export const trigFunctions = [
  "sin",
  "cos",
  "csc",
  "cot",
  "sec",
  "tan",
  "sin^{-1}",
  "cos^{-1}",
  "tan^{-1}",
];

export const trigLatex = [
  /sin/g,
  /cos/g,
  /csc/g,
  /cot/g,
  /sec/g,
  /tan/g,
  /sin^{-1}/g,
  /cos^{-1}/g,
  /tan^{-1}/g,
];
